import React, {useState} from "react";

export const useInit = (routes) => {

    const [answersOnQuestions, setAnswersOnQuestions] = useState(() => {
        const initState = {
            age: localStorage.getItem('age') || "",
            gender: localStorage.getItem('gender') || "male",
            units: localStorage.getItem('units') || "mt",
            heightCm: localStorage.getItem('heightCm') || "",
            heightIn: localStorage.getItem('heightIn') || "",
            heightFt: localStorage.getItem('heightFt') || "",
            weightKg: localStorage.getItem('weightKg') || "",
            weightLb: localStorage.getItem('weightLb') || "",
            goalWeight: localStorage.getItem('goalWeight') || "",
            neededWeight: localStorage.getItem('neededWeight') || "",
            needWeightKg: localStorage.getItem('needWeightKg') || "",
            needWeightLb: localStorage.getItem('needWeightLb') || "",
            goalEventName: localStorage.getItem('goalEventName') || "",
        }

        routes.map(({name: componentName}) => {

            const isStorageArray = localStorage.getItem(`${componentName}IsArray`) || 'false',
                  dataFromStorage = isStorageArray === 'true'
                      ? localStorage.getItem(componentName) === ''
                          ? []
                          : localStorage.getItem(componentName).split(',')
                      : localStorage.getItem(componentName)



            initState[componentName] = dataFromStorage || null
        })

        return initState
    })

    return [answersOnQuestions, setAnswersOnQuestions]
}